// PUBLIC — no authentication required.
// To disable: comment out the /public/documentation-intro route in App.js.

import React from 'react';
import { Container, Card, Alert } from 'react-bootstrap';
import { DesignDocumentationSection, ThreatModelSection } from '../shared/DocumentationIntroContent';

export default function PublicDocumentationIntro() {
  return (
    <Container className="py-5">
      <Card className="shadow-lg border-0 mb-4">
        <Card.Body>
          <h2 className="mb-3">📚 Documentation Concepts Intro</h2>
          <p>
            This is a public preview of the documentation-concepts step participants complete before starting their pentest.
            It introduces the design documentation and threat model artifacts used throughout the study.
          </p>
          <Alert variant="warning" className="mb-3">
            <strong>⚠️ Note:</strong> The diagrams below are <strong>illustrative examples</strong> only, meant to help you get familiar with each documentation type —
            they are <strong>not</strong> a real target website.
          </Alert>

          <DesignDocumentationSection />
          <ThreatModelSection />
        </Card.Body>
      </Card>
    </Container>
  );
}
